import Quote from './Quote';
import Intro from './Intro';

const GetQuote = () => (
  <>
    <Intro />
    <Quote />
  </>
);

export default GetQuote;
